var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9523_3455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.48254,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#1A56DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 22.9825V9.64921C21.8333 9.20718 21.6577 8.78326 21.3452 8.4707C21.0326 8.15814 20.6087 7.98254 20.1667 7.98254H11.8333C11.3913 7.98254 10.9674 8.15814 10.6548 8.4707C10.3423 8.78326 10.1667 9.20718 10.1667 9.64921V22.9825M21.8333 22.9825H10.1667M21.8333 22.9825H23.5M21.8333 22.9825H17.6667M10.1667 22.9825H8.5M10.1667 22.9825H14.3333M17.6667 22.9825V18.8159C17.6667 18.5949 17.5789 18.3829 17.4226 18.2266C17.2663 18.0703 17.0543 17.9825 16.8333 17.9825H15.1667C14.9457 17.9825 14.7337 18.0703 14.5774 18.2266C14.4211 18.3829 14.3333 18.5949 14.3333 18.8159V22.9825M17.6667 22.9825H14.3333M13.5 11.3159H14.3333M13.5 14.6492H14.3333M17.6667 11.3159H18.5M17.6667 14.6492H18.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9523_3455",
    x: 0,
    y: 0.482544,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9523_3455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9523_3455",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.deec755c88c9a35dc62389eef9ab7a88.svg";
export { ForwardRef as ReactComponent };